/**
 * Helper functions for avatar management
 */

/**
 * Get the display URL for a user's avatar/profile picture
 * Handles both custom photos (base64) and predefined avatars (DiceBear)
 * 
 * @param {Object} user - User object with profile_picture field
 * @returns {string} URL for the avatar image
 */
export const getAvatarUrl = (user) => {
  if (!user) return null;
  
  // Check all possible avatar fields
  const profilePicture = user.avatar || user.profile_picture || user.profile_photo || user.picture;
  
  if (!profilePicture) return null;
  
  // Check if it's a predefined avatar (format: "avatar:style:seed")
  if (profilePicture.startsWith('avatar:')) {
    const [, style, seed] = profilePicture.split(':');
    return `https://api.dicebear.com/7.x/${style}/svg?seed=${seed}`;
  }
  
  // Otherwise, it's a custom photo (base64 data URL or URL)
  return profilePicture;
};

/**
 * Check if the avatar is a predefined avatar (not a custom photo)
 * 
 * @param {Object} user - User object
 * @returns {boolean} True if predefined avatar
 */
export const isPredefinedAvatar = (user) => {
  if (!user) return false;
  
  const profilePicture = user.profile_picture || user.profile_photo;
  return profilePicture && profilePicture.startsWith('avatar:');
};

/**
 * Get user's display name (pseudo or name)
 * 
 * @param {Object} user - User object
 * @returns {string} Display name
 */
export const getUserDisplayName = (user) => {
  return user?.pseudo || user?.name || 'Utilisateur';
};
